import * as React from 'react'
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { SkuInfoBlock, ImageSkuBlock } from "@components"
import { useBuildExternalURL } from "@hooks"
import { usePriceChangesShowEvolution } from '../@hooks'
import { priceChangesPriceEvolutionFilters } from '../../@signals'


export default function skuColumn() {
	return [{
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'Product Name',
		options: {
			headerAlign: 'center',
			setCellHeaderProps: () => ({ sx: {
				minWidth: 180
			}}),
			customBodyRowRenderLite: (value, { category, brand, ean, skuID, skuName, siteID, productID, externalSeller, reference, date }) => {
				const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })
				return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
					<Box>
						<ImageSkuBlock
							skuID={skuID}
							skuName={skuName}
						/>
					</Box>
					<Box>
						<SkuInfoBlock
							sku={value}
							skuID={skuID}
							category={category}
							brand={brand}
							ean={ean}
							reference={reference}
							productURL={productURL}
						/>
						<ShowPriceEvolutionCell siteID={siteID} productID={productID} skuID={skuID} externalSeller={externalSeller} />
					</Box>
				</Box>
			}
		}
	}]
}

const ShowPriceEvolutionCell = ({siteID, productID, skuID, externalSeller}) => {

	const { handleClickShowPriceEvolution, isOpenPriceEvolutionChart } = usePriceChangesShowEvolution(siteID, productID, skuID, externalSeller)
	const isOpenChartClass = isOpenPriceEvolutionChart ? 'is-open' : ''

	return <Box data-tour-trigger className={`${isOpenChartClass}`} sx={{ display: 'flex', alignItems: 'flex-end', mt: 2}} onClick={() => handleClickShowPriceEvolution(priceChangesPriceEvolutionFilters)} >
		 <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
		 Show Price & Stock Evolution
		 </Typography>
		 <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
	</Box>
 
}